import * as React from 'react';

import { TooltipDesktop } from '@cian/ui-kit/tooltip';
import { Link } from '../Link';

import * as styles from './NewbuildingFeatures.css';
import { Tour3d16, BuildingProcess16, Comments16, InteractivePlanirovka16 } from '@cian/ui-kit';

interface INewbuildingFeatureProps {
  url: string;
  title: string;
  dataMark?: string;
  type: 'progressOfConstructions' | 'featureReviews' | 'featureMvk' | 'featureTimeline' | 'featureTour';

  onClick(): void;
}

const assetMap: { [index: string]: React.ReactNode } = {
  featureTimeline: <BuildingProcess16 color={'white_100'} />,
  progressOfConstructions: <BuildingProcess16 color={'white_100'} />,
  featureReviews: <Comments16 color={'white_100'} />,
  featureMvk: <InteractivePlanirovka16 color={'white_100'} />,
  featureTour: <Tour3d16 color={'white_100'} />,
};

export function NewbuildingFeature(props: INewbuildingFeatureProps) {
  const { url, title, type, onClick } = props;
  const icon = assetMap[type];

  return (
    <div className={styles['feature-container']}>
      <TooltipDesktop title={title} placement="bottom">
        <Link target="blank" url={url} linkStyle={styles['feature']} onClick={onClick}>
          <div className={styles['feature-icon-wrapper']}>{icon}</div>
        </Link>
      </TooltipDesktop>
    </div>
  );
}
